import { create } from 'zustand'

export type Locale = 'pt' | 'en'

interface LanguageState {
  currentLocale: Locale
  setLocale: (locale: Locale) => void
}

export const useLanguageStore = create<LanguageState>((set) => ({
  currentLocale: 'pt',
  setLocale: (locale) => set({ currentLocale: locale }),
}))

export default useLanguageStore
